import React, { useEffect } from "react";
import {
  Card,
  CardHeader,
  IconButton,
  CardContent,
  FormHelperText,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import EditIcon from "@material-ui/icons/Edit";
import { compose } from "../../utils/compose";
import { connect } from "react-redux";
import InlineSpinner from "../UI/InlineSpinner/InlineSpinner";
import { billingInfoActions } from '../../store/actions/billingInformation/billingInformation';
import UserBillingInfo from "./UserBillingInfo";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  card: {},
  cardTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  }
}));

const BillingInformationSummary = props => {
  const classes = useStyles();
  const { billingInformation, onFetchBillingInfo, onEdit } = props;
  const { t } = useTranslation();

  useEffect(() => {
    onFetchBillingInfo();
  }, [onFetchBillingInfo]);

  function editBillingInformationHandler() {
    onEdit();
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        className={classes.cardTitle}
        title={t("billingInformationTitle")}
        action={
          <IconButton
            className={classes.action}
            onClick={editBillingInformationHandler}
            color="inherit"
          >
            <EditIcon />
          </IconButton>
        }
      />
      <CardContent>
        {billingInformation.fetching ? (
          <InlineSpinner size="small" align="center" />
        ) : (
          <>
            {billingInformation.error ? (
              <FormHelperText className="MuiFormHelperText-root Mui-error">
                {billingInformation.error}
              </FormHelperText>
            ) : (
              <>
                {billingInformation.data.BillingInformation === null ? (
                  <div style={{textAlign: "center"}}>
                  <Button color="primary" variant="contained" onClick={editBillingInformationHandler}>
                    {t('addBillingInformation')}
                  </Button>
                  </div>
                ) : (
                  <UserBillingInfo info={billingInformation.data.BillingInformation} />
                )}
              </>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

const mapStateToProps = state => ({
  billingInformation: state.billingInformation,
});

const mapDispatchToProps = dispatch => ({
  onFetchBillingInfo: () => dispatch(billingInfoActions.fetch())
})

const composed = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(BillingInformationSummary);

export default composed;
